import { Dispatch } from '@reduxjs/toolkit'
import { ClientDocumentModel } from 'api/Documents/Types/ClientDocument'
import { DocumentApiClient } from 'utils/api/documentApi'

import { documentsSlice } from './documents.slice'

export const uploadClientDocumentsAction = (
  files: ClientDocumentModel[],
  documentApiClient: DocumentApiClient
) => {
  return async (): Promise<void> => {
    try {
      await documentApiClient.uploadDocumentClient(files)
    } catch (e) {
      console.error('Cannot get documents', e)
    }
  }
}

export const getDocumentsTypesByCategory = (
  categoryId: string | number,
  documentApiClient: DocumentApiClient
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const { types } = await documentApiClient.getDocumentTypesByCategory(categoryId)
      dispatch(documentsSlice.actions.fetchDocumentTypesByCategory({ categoryId, types }))
    } catch (e) {
      console.error('Cannot get document types', e)
    }
  }
}

export const fetchDocumentCategoriesTypeAction = (documentApiClient: DocumentApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const categoryTypes = await documentApiClient.getDocumentCategoriesType()
      dispatch(documentsSlice.actions.fetchDocumentCategoryType(categoryTypes))
    } catch (e) {
      console.error('Cannot get document category type', e)
    }
  }
}

export const fetchDocumentTagTypeAction = (documentApiClient: DocumentApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await documentApiClient.getDocumentTagType()
      dispatch(documentsSlice.actions.fetchDocumentTagType(response))
    } catch (e) {
      console.error('Cannot get document tags', e)
    }
  }
}

export const fetchDocumentStatusReasonsActions = (documentApiClient: DocumentApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const data = await documentApiClient.getDocumentStatusReasons()
      dispatch(documentsSlice.actions.fetchDocumentStatusReasons(data))
    } catch (e) {
      console.error('Cannot get document status reasons', e)
    }
  }
}

export const fetchDocumentStatusesAction = (documentApiClient: DocumentApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await documentApiClient.getDocumentStatusesType()
      dispatch(documentsSlice.actions.fetchDocumentStatusesType(response))
    } catch (e) {
      console.error('Cannot get document status type', e)
    }
  }
}
